import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const MessageIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
    >
      <path
        d="M8.08333 9.5C8.08333 9.61051 8.03943 9.71649 7.96129 9.79463C7.88315 9.87277 7.77717 9.91667 7.66667 9.91667C7.55616 9.91667 7.45018 9.87277 7.37204 9.79463C7.2939 9.71649 7.25 9.61051 7.25 9.5C7.25 9.3895 7.2939 9.28351 7.37204 9.20537C7.45018 9.12723 7.55616 9.08334 7.66667 9.08334C7.77717 9.08334 7.88315 9.12723 7.96129 9.20537C8.03943 9.28351 8.08333 9.3895 8.08333 9.5ZM8.08333 9.5H7.66667M12.25 9.5C12.25 9.61051 12.2061 9.71649 12.128 9.79463C12.0498 9.87277 11.9438 9.91667 11.8333 9.91667C11.7228 9.91667 11.6168 9.87277 11.5387 9.79463C11.4606 9.71649 11.4167 9.61051 11.4167 9.5C11.4167 9.3895 11.4606 9.28351 11.5387 9.20537C11.6168 9.12723 11.7228 9.08334 11.8333 9.08334C11.9438 9.08334 12.0498 9.12723 12.128 9.20537C12.2061 9.28351 12.25 9.3895 12.25 9.5ZM12.25 9.5H11.8333M16.4167 9.5C16.4167 9.61051 16.3728 9.71649 16.2946 9.79463C16.2165 9.87277 16.1105 9.91667 16 9.91667C15.8895 9.91667 15.7835 9.87277 15.7054 9.79463C15.6272 9.71649 15.5833 9.61051 15.5833 9.5C15.5833 9.3895 15.6272 9.28351 15.7054 9.20537C15.7835 9.12723 15.8895 9.08334 16 9.08334C16.1105 9.08334 16.2165 9.12723 16.2946 9.20537C16.3728 9.28351 16.4167 9.3895 16.4167 9.5ZM16.4167 9.5H16M1 12.8444C1 14.6222 2.24778 16.1711 4.00778 16.43C5.21555 16.6078 6.43555 16.7444 7.66667 16.84V22L12.3156 17.3522C12.5457 17.123 12.8552 16.9909 13.18 16.9833C15.3485 16.93 17.5117 16.7452 19.6578 16.43C21.4189 16.1711 22.6667 14.6233 22.6667 12.8433V6.15667C22.6667 4.37667 21.4189 2.82889 19.6589 2.57C17.0677 2.18968 14.4522 1.99918 11.8333 2C9.17555 2 6.56222 2.19445 4.00778 2.57C2.24778 2.82889 1 4.37778 1 6.15667V12.8433V12.8444Z"
        stroke={color}
        strokeWidth={strokeWidth || 1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </BaseIcon>
  ),
);

MessageIcon.displayName = 'MessageIcon';
